




























































































import { Component } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import questionApi from '@/api/question/index.ts'

@Component({
  components: {}
})
export default class QuestionDetail extends AbpBase {
  questionDetail: any = {}

  questions = []

  alphabetList: any[] = []

  columns = [
    {
      title: '选项',
      slot: 'text'
    },
    {
      title: '数量',
      key: 'count'
    },
    {
      title: '比例',
      slot: 'rate'
    }
  ]

  columns2 = [
    {
      title: '序号',
      slot: 'num',
      align: 'center',
      width: 80
    },
    {
      title: '答案文本',
      align: 'center',
      key: 'text'
    }
  ]
  showModal = false
  selectIndex = -1

  // 填空列表
  get blankList() {
    let list = []
    if (this.selectIndex >= 0 && this.questions.length > 0) {
      list = this.questions[this.selectIndex]['values'].map(item => {
        return {
          text: item
        }
      })
    }
    return list
  }

  get blankTitle() {
    let title = ''
    if (this.selectIndex >= 0 && this.questions.length > 0) {
      title = this.questions[this.selectIndex]['title']
    }
    return title
  }

  created() {
    this.upperCaseChars()
    this.getQuestionnaire()
  }

  /**
   * 生成字母列表 A-Z
   */
  upperCaseChars() {
    //生成大写字母，A的Unicode值为65
    this.alphabetList = []
    for (var i = 65; i < 91; i++) {
      this.alphabetList.push(String.fromCharCode(i))
    }
  }

  /**
   * 获取问卷详情
   */
  getQuestionnaire() {
    let id = this.$route.query['id']
    if (id) {
      questionApi.getQuestionnaireStatics(id.toString()).then(res => {
        if (res.data) {
          this.questionDetail = res.data
          if (res.data.questions) {
            this.questions = res.data.questions || []
          }
        }
      })
    }
  }

  /**
   * 查看填空题答案
   */
  showFn(index) {
    if (index >= 0) {
      this.showModal = true
      this.selectIndex = index
    }
  }

  cancelFn() {
    this.showModal = false
  }
}
